export default __webpack_public_path__ + "static/media/ico-trade-in.d110c5c1.svg";